import React from 'react';
import { motion } from 'framer-motion';
import { Phone, ArrowRight } from 'lucide-react';
export function FinalCTA() {
  const phoneNumber = '(949) 555-0117';
  const phoneLink = 'tel:9495550117';
  return <section className="py-24 bg-white relative overflow-hidden" id="audit" data-id="element-9">
      <div className="absolute inset-0 bg-brand-600 transform -skew-y-2 origin-top-left z-0" data-id="element-10"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-11">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-slate-100" data-id="element-12">
          <div className="grid md:grid-cols-2" data-id="element-13">
            <div className="p-10 md:p-12 lg:p-16 flex flex-col justify-center" data-id="element-14">
              <motion.h2 initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-4 tracking-tight" data-id="element-15">
                Ready to stop guessing and start growing?
              </motion.h2>
              <motion.p initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.1
            }} className="text-lg text-slate-600 mb-8" data-id="element-16">
                Call us directly to speak with a senior strategist, or request a
                free, no-fluff technical and content audit of your site.
              </motion.p>

              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2
            }} className="flex flex-col gap-4" data-id="element-17">
                <a href={phoneLink} className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-bold rounded-xl text-white bg-brand-600 hover:bg-brand-700 shadow-lg shadow-brand-500/30 hover:shadow-brand-500/50 transition-all gap-2 w-full sm:w-auto" data-id="element-18">
                  <Phone className="w-5 h-5" data-id="element-19" />
                  Call {phoneNumber}
                </a>
                <div className="text-center text-sm text-slate-500 font-medium" data-id="element-20">
                  Or fill out the form to get your audit.
                </div>
              </motion.div>
            </div>

            <div className="bg-slate-50 p-10 md:p-12 lg:p-16 border-l border-slate-100" data-id="element-21">
              <h3 className="text-xl font-bold text-slate-900 mb-6" data-id="element-22">
                Request your free SEO audit
              </h3>
              <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-23">
                <div data-id="element-24">
                  <label htmlFor="name" className="block text-sm font-medium text-slate-700 mb-1" data-id="element-25">
                    Full Name
                  </label>
                  <input type="text" id="name" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none transition-all" placeholder="Jane Doe" data-id="element-26" />
                </div>
                <div data-id="element-27">
                  <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-1" data-id="element-28">
                    Work Email
                  </label>
                  <input type="email" id="email" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none transition-all" placeholder="jane@company.com" data-id="element-29" />
                </div>
                <div data-id="element-30">
                  <label htmlFor="website" className="block text-sm font-medium text-slate-700 mb-1" data-id="element-31">
                    Website URL
                  </label>
                  <input type="url" id="website" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none transition-all" placeholder="https://company.com" data-id="element-32" />
                </div>
                <button type="submit" className="w-full inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-bold rounded-lg text-white bg-slate-900 hover:bg-slate-800 transition-all gap-2 mt-2" data-id="element-33">
                  Get My Audit
                  <ArrowRight className="w-4 h-4" data-id="element-34" />
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>;
}